export default __webpack_public_path__ + "static/11-3fcc8a4649211770d32222f2a9c5a862.png";